export const maskDefinitions = {
  0: /\d/,
  9: /\d/,
  A: /[a-zA-Z]/,
  a: /[a-zA-Z]/,
  '*': /[a-zA-Z0-9]/,
  n: /\d/,
  N: /\d/,
}

export const strToMask = (str) =>
  String(str)
    .split('')
    .map((s) => (maskDefinitions[s] ? maskDefinitions[s] : s))
